import { AxiosInstance, AxiosResponse, AxiosRequestConfig, Method } from 'axios'
import { HlLoading } from 'hongluan-ui'
import { CommonUtils, Indexable, EmptyUtils } from 'fx-front-utils'
import { Loading } from '../loading'

/**
 * 返回类型基础类
 */

export interface EmptyResponseData {
  [key: string]: any
}

export interface ResponseData {
  code: number | string
  desc?: string
  tips?: string
  data: unknown
}

export interface MockResponseData {
  code?: number | string
  data: ResponseData
  message: string
  meta: any
  success: boolean
}

export interface TableList {
  list: Indexable<any>[]
}
/**
 * api 调用辅助类
 */
export class RequestAxios {
  private serverObj: AxiosInstance
  private arrayBufferUrls: string[]
  private notTranslateEmpty: string[]
  private showMsgUrls: string[]
  private successCodes: string[]
  private ifGetFileNameFromHeader: (url: string) => boolean
  constructor(config: any) {
    this.serverObj = config.serverObj
    this.arrayBufferUrls = config.arrayBufferUrls
    this.notTranslateEmpty = config.notTranslateEmpty
    this.showMsgUrls = config.showMsgUrls
    this.successCodes = config.successCodes || ['0']
    this.ifGetFileNameFromHeader = config.ifGetFileNameFromHeader || (() => false)
  }

  post(url: string, data: unknown = null, headers: Record<string, any> = {}) {
    return this.http(url, data, 'POST', headers)
  }
  put(url: string, data: unknown = null, headers: Record<string, any> = {}) {
    return this.http(url, data, 'PUT', headers)
  }
  get(url: string, headers: Record<string, any> = {}) {
    return this.http(url, null, 'GET', headers)
  }
  delete(url: string, headers: Record<string, any> = {}) {
    return this.http(url, null, 'DELETE', headers)
  }

  http(url: string, data: unknown, method: Method, headers: Record<string, any> = {}) {
    return new Promise<ResponseData>((resolve, reject) => {
      const config: AxiosRequestConfig = {
        url,
        method,
        headers,
        data,
      }
      const showDownloading = this.arrayBufferUrls.some(item => config.url?.indexOf(item) !== -1)
      const tableNotTranslateEmpty = this.notTranslateEmpty.some(item => config.url?.indexOf(item) !== -1)
      let loadingInstance: any = null
      if (showDownloading) {
        loadingInstance = HlLoading.service({
          lock: true,
          text: '下载中',
          spinner: 'fw-icon-loading',
          background: 'rgba(1, 1, 1, 0.1)',
        })
      }
      this.serverObj.request(config).then(
        (response: AxiosResponse) => {
          const respData: ResponseData = response.data
          if (respData instanceof ArrayBuffer) {
            const fileName = this.ifGetFileNameFromHeader(config.url) ? response.headers['content-disposition']?.split('filename*=utf-8\'\'')[1] : 'file.dat'
            CommonUtils.handleFileBuffer(response, fileName)
            loadingInstance && loadingInstance.close()
            resolve({ code: 0, data: true, desc: '下载成功' })
          } else {
            const respCode = respData.code + ''
            const isInShowMsgUrls = this.showMsgUrls.some(item => config.url?.indexOf(item) !== -1)
            if (isInShowMsgUrls && this.successCodes.includes(respCode)) {
              Loading.showMessageTip(1, respData.desc || '操作成功')
              resolve(respData)
            } else {
              // 格式化表格中的空属性
              if (this.successCodes.includes(respCode) && respData.data && (respData.data as TableList)?.list && !tableNotTranslateEmpty) {
                (respData.data as TableList).list = EmptyUtils.formatArray((respData.data as TableList).list)
              }
              this.successCodes.includes(respCode) ? resolve(respData) : reject(`[FX]Request(${config.url}): response code is not successful. Response Data: ` + JSON.stringify(respData))
            }
          }
        },
        (err: unknown) => {
          loadingInstance && loadingInstance.close()
          reject(err)
        },
      )
    })
  }
}

let axiosRequestSingle: RequestAxios

const getRequest = (config: {
  showMsgUrls: string[]
  arrayBufferUrls: string[]
  notTranslateEmpty: string[]
  successCodes?: string[]
  ifGetFileNameFromHeader?: (url: string) => boolean
  serverObj: AxiosInstance
}) => {
  if (!axiosRequestSingle) {
    axiosRequestSingle = new RequestAxios(config)
  }
  return axiosRequestSingle
}

export { getRequest }
